import { render, staticRenderFns } from "./WordTypeFilter.vue?vue&type=template&id=3551edcb&scoped=true&"
import script from "./WordTypeFilter.vue?vue&type=script&lang=js&"
export * from "./WordTypeFilter.vue?vue&type=script&lang=js&"
import style0 from "@/resources/styles/results.css?vue&type=style&index=0&id=3551edcb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3551edcb",
  null
  
)

export default component.exports